<template>
  <div>
    <treeselect
      ref="tresselect"
      :clearOnSelect="true"
      :placeholder="placeholder || $t('global.select')"
      :loadOptions="loadOptions"
      v-bind="{...configurations[config], ...custom, disabled: disabled}"
      :noOptionsText="$t('global.no_options_available')"
      :noResultsText="$t('global.no_results_found')"
      :options="options"
      :value="value" @input="$emit('input', $event)"
      :normalizer="normalizer"
      @close="$emit('close', $event)"
      class="higlight-invalid-treeselect">

      <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
        :class="[labelClassName, {
        'disabled-treeselect-label-cust': !node.raw.pinfo && !showAllTags,
        //'softlocked-treeselect-label-cust': node.raw.isSoftLocked
        }]" @mousedown="if(node.raw.isLocked){ $event.stopPropagation(); $event.preventDefault()}">
        <span v-if="node.raw.pinfo != null && showColorCircle" :style="`color:${node.raw.pinfo.color}`"><i class="fa fa-circle mr-1"></i></span>
        {{node.raw.id}} {{ node.raw.label }}
      </label>
      <div slot="value-label" slot-scope="{ node }" :class="{'hasnot-pinfo': node.raw.pinfo === null}">
        <span v-if="node.raw.pinfo != null && showColorTag" class="value-color-info" :style="`background-color:${node.raw.pinfo.color}`"/>{{node.raw.id}} {{ node.raw.label }}
      </div>
    </treeselect>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VT } from '@/store/types';
import Services from '@/services/index';
import Treeselect, { ASYNC_SEARCH, LOAD_ROOT_OPTIONS, LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect';

export default {
  mounted() {
    this.preload();
  },
  props: {
    config: { type: String, default: 'async' }, // async, delayed
    custom: { type: Object, default() { return {}; } }, // multiple, ...
    // Custom filter for items when searching: customFilter({ classifier })
    customFilter: { type: Function, default: null },
    // Disable input, @TODO use flaaback and skip loading
    disabled: { type: Boolean, default: false },
    // // Display values as breadrumbs
    // breadcrumbs: { type: Boolean, default: true },
    // Expand disabled search results by default
    expandDisabled: { type: Boolean, default: true },
    // If values are being searced, show their children
    fillSearchChildren: { type: Boolean, default: true },
    // Do not lock, just higlight differently invalid searchResults
    softLockSearch: { type: Boolean, default: true },
    // Display search results as tree, if false results will be flat list
    searchTree: { type: Boolean, default: true },
    // Do not load all children at the beggining, cannot be used with some filters
    delayed: { type: Boolean, default: true },
    showColorCircle: { type: Boolean, default: false },
    showColorTag: { type: Boolean, default: false },
    showAllTags: { type: Boolean, default: false },
    value: { type: [Array, Number], default: null },
    // Fallback value-Used if initial classifier (value) is not loaded (delayed tree loading + store) and must be shown
    // (this takes preference over cached values in store even if store contains them)
    fallback: { type: Object, default: null },
    // Cut bredcrums to limit chars shown. This is approximate
    maxChars: { type: Number, default: 60 },
    placeholder: { type: String },
    // items: { type: Array },
  },
  data() {
    return {
      isSearch: false, // Set mannually to allow conditional rendering when certain results match search
      options: [],
      // Allow easy switching of different setups - these are passed as props to treeselect
      configurations: {
        async: {
          cacheOptions: false,
          async: true,
          defaultOptions: true, // Render full tree even without searching
        },
        delayed: {
          async: false,
        }
      }
    };
  },
  components: { Treeselect }, // ClassifierCrumbs
  watch: {
    // any_cust_filters(fresh, old) { if (fresh.join() !== old.join()) this.reload(); },
    // 'activeProject'() { this.reload(); },
  },
  computed: {
    ...mapGetters('Tags', {
      lookupClassifierById: 'lookupTagById',
      getSingleLevelChildren: 'getSingleLevelChildren',
      getAllChildrenTree: 'getAllChildrenTree',
      searchClassifiersTree: 'searchTagsTree',
    }),
    ...mapGetters('Project', ['currentProjectTags']),
    ...mapGetters('Auth', ['activeProject']),
  },
  methods: {
    ...mapActions('Tags', {
      loadClassifiers: VT.TAGS_LOAD,
      loadTreeDelayed: VT.TAGS_TREE_LOAD_DELAY,
      searchFlatDelayed: VT.TAGS_SEARCH_FLAT,
      searchTreeDelayed: VT.TAGS_SEARCH_TREE,

    }),
    tag_sorting(a, b) {
      const tags = this.activeProject.project_tags;
      if (tags) {
        const isAInTags = tags.some((tag) => tag.tag_id === a.id);
        const isBInTags = tags.some((tag) => tag.tag_id === b.id);
        if (isAInTags && !isBInTags) {
          return -1;
        }
        if (!isAInTags && isBInTags) {
          return 1;
        }
      }
      if (a.id > b.id) {
        return 1;
      }
      return -1;
    },
    loadOptions({
      action, parentNode, callback, searchQuery
    }) {
      if (action === ASYNC_SEARCH) {
        this.isSearch = this.customFilter || searchQuery.length > 0;
        const searchFn = this.searchTree ? this.searchTreeDelayed : this.typessearchFlatDelayed;
        searchFn({
          query: searchQuery,
          fillChildren: this.fillSearchChildren,
          customFilter: this.customFilter,
          mergeWithInfo: true,
        }).then((results) => {
          results.sort(this.tag_sorting);
          if (this.activeProject.hide_other_tags && this.currentProjectTags.length && !this.showAllTags) {
            results = results.filter((t) => t.pinfo !== null || ((Array.isArray(this.value) && this.value.includes(t.id)) || this.value === t.id));
          }
          callback(null, results);
          this.$refs['tresselect'].traverseAllNodesDFS((node) => {
            if (node.isBranch) {
              node.isExpanded = !node.raw.searchMatch;
            }
          });
          this.$nextTick(() => {
            this.$refs['tresselect'].resetHighlightedOptionWhenNecessary(true);
          });
        }).catch(() => {
          callback(new Error(this.$dt('tags.dropdown_failed_load_search', 'Failed to search')));
        });
      } else if ((this.customFilter)
        && [LOAD_ROOT_OPTIONS, LOAD_CHILDREN_OPTIONS].includes(action)) {
        console.warn('delayed loading not allowed with subtype filter'); // For now
      } else if (action === LOAD_ROOT_OPTIONS) {
        this.loadTreeDelayed({ id: parentNode ? parentNode.id : 0 }).then((children) => {
          this.options = children || [];
          callback();
        }).catch(() => {
          callback(new Error(this.$dt('tags.dropdown_failed_load_root', 'Failed to load')));
        });
      } else if (action === LOAD_CHILDREN_OPTIONS) {
        this.loadTreeDelayed({ id: parentNode ? parentNode.id : 0 }).then((children) => {
          parentNode.children = children || false;
          callback();
        }).catch(() => {
          callback(new Error(this.$dt('tags.dropdown_failed_load_children', 'Failed to load')));
        });
      }
    },
    fallbackValue(id) {
      if (this.fallback && this.fallback.id === id) {
        // @TODO this (making path arr) might be unnececary in future when returning classifiers preformated
        if (!this.fallback.pathArr && this.fallback.path) {
          this.fallback.pathArr = this.fallback.path.split(',').map(Number);
          this.fallback.pathArr.pop();
        } else if (!this.fallback.pathArr) this.fallback.pathArr = [id];
        return this.fallback;
      }
      return this.lookupClassifierById({ id }) || { id, label: this.$dt('tags.not_found', 'unknown') };
    },
    normalizer(node) {
      const result = node;
      if (this.isSearch) {
        if (this.expandDisabled) result.isDefaultExpanded = !node.searchMatch;
        if (!this.expandDisabled && node.searchMatch) {
          this.$refs['tresselect'].traverseAllNodesDFS((rawNode) => {
            if (rawNode.isBranch) {
              rawNode.isExpanded = true;
            }
          });
        }
        const invalidSubtype = (
          (this.customFilter && !this.customFilter({ item: node }))
        );
        if (!this.softLockSearch || invalidSubtype) {
          if (this.custom.multiple) {
            result.isDisabled = invalidSubtype || !node.searchMatch;
          }
          result.isLocked = invalidSubtype || !node.searchMatch;
        } else {
          result.isSoftLocked = !node.searchMatch;
        }
      }
      return result;
    },
    reload() {
      const tree = this.$refs['tresselect'];
      this.preload();
      tree.remoteSearch = Object.create(null);
      tree.localSearch.countMap = Object.create(null);
      if (!tree.options && !tree.async && tree.autoLoadRootOptions) tree.loadRootOptions();
      if (tree.alwaysOpen) tree.openMenu();
      if (tree.async && tree.defaultOptions) tree.handleRemoteSearch();
    }, // Debounce helps when badly implementated
    preload() {
      if (this.config !== 'async') {
        this.isSearch = this.customFilter;
        const preloadFn = this.delayed ? this.getSingleLevelChildren : this.getAllChildrenTree;
        this.loadClassifiers({ }).then(() => { // @TODO better use action not getters
          this.options = preloadFn(
            {
              id: 0, customFilter: this.customFilter
            }
          );
        });
      }
    }
  }
};
</script>
<style scoped lang=scss>
  .disabled-treeselect-label-cust{
    color: $secondary;
  }
  .value-color-info {
    display: inline-block;
    position: absolute;
    margin: -2px 0 0 -5px;
    height:5px;
    width:5px;
    border-radius: 3px;
  }

</style>

<style lang=scss>
  .form-group.is-invalid .higlight-invalid-treeselect>.vue-treeselect__control,
  .form-group.is-invalid .higlight-invalid-treeselect>.vue-treeselect__control:hover
  {
    border-color:$red;
  }
</style>
